<template>
  <div class="dljm" v-loading.fullscreen.lock="fullscreenloading">
    <!-- <img src="../../assets/登录_slices/logo.png" alt=""> -->
    <div class="nrbox">
        <div class="nrboxl">
            <h2>Hi, 你好！</h2>
            <h3>欢迎进入PC端控制软件</h3>
           <p>Welcome to PC control software</p>
        </div>
        <div class="nrboxr">
            <h3>Please Sign In</h3>
            <div style="cursor:pointer;"><img src="../../assets/登录_slices/user.png" alt=""><input type="text" placeholder="请输入登录账号" v-model="loginname"></div>
            <div style="cursor:pointer;"><img src="../../assets/登录_slices/pass.png" alt=""><input type="password" placeholder="请输入登录密码" v-model="password"></div>
            <span style="cursor:pointer;" @click="RslEvLogin">登录</span>
        </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      fullscreenloading: false,
      loginname: '',
      password: '',
      ua:''
    }
  },
  mounted () {
    // 检查登录状态
    this.RslEvCheckLogin()
    //
    Vue.prototype.CheckRslEvKeyWord()
  },
  methods: {
    RslEvLogin: function () {
      var that = this
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        timestamp: timestamp,
        loginname: that.loginname,
        password: that.password
      }
      that.fullscreenloading = true
      axios.post(Vue.prototype.global.Url_RslEvLogin, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            // 保存数据
            localStorage.setItem('Useriderp', response.data.Useriderp)
            localStorage.setItem('Roletype', response.data.Roletype)
            localStorage.setItem('Authtokenrslev', response.data.Authtokenrslev)
            // 跳转
            that.GoToNextPage()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.fullscreenloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          Vue.prototype.FunAlertMsg('网络出错！'+error.toString())
          that.fullscreenloading = false
        })
    },
    RslEvCheckLogin: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignRslEv(data)
      axios.post(Vue.prototype.global.Url_RslEvCheckLogin, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            // 跳转
            that.GoToNextPage()
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GoToNextPage () {
      var that = this
      var Roletype = localStorage.getItem('Roletype')
      if (Roletype === '1' || Roletype === '3') {
        that.$router.push('/RslEvSgView')
      }
      if (Roletype === '2') {
        that.$router.push('/RslEvGccsView')
      }
    }
  }
}
</script>
<style scoped>
.dljm{
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
    background: url(../../assets/登录_slices/loginbj.png) no-repeat;
    background-size:cover;
}
.dljm>img{
    display: block;
    width: 153px;
    height: 66px;
    position: absolute;
    top: 24px;
    left: 37px;
}
.nrbox{
    margin: 166px auto;
    width: 832px;
    height: 388px;
    display: flex;
}
.nrboxl>h2{
    margin-top: 68px;
    display: block;
   width: 284px;
height: 93px;
font-size: 62px;
font-weight: 500;
color: #FFFFFF;
line-height: 73px;
text-shadow: 0px 2px 18px rgba(39, 86, 255, 0.28);
text-align: left;
}

.nrboxl>h3{
    margin-top: 6px;
    display: block;
   width: 393px;
height: 54px;
font-size: 36px;
font-weight: 500;
color: #FFFFFF;
line-height: 42px;
text-shadow: 0px 2px 18px rgba(39, 86, 255, 0.28);
text-align: left;
}
.nrboxl>p{
    margin-top: 44px;
    display: block;
    width: 382px;
height: 27px;
font-size: 18px;
font-weight: 500;
color: #FFFFFF;
line-height: 21px;
text-shadow: 0px 2px 18px rgba(39, 86, 255, 0.28);
text-align: left;
}
.nrboxr{
    margin-left: 83px;
    position: relative;
width: 367px;
height: 388px;
background: rgba(255, 255, 255, 0.95);
border-radius: 2px 2px 2px 2px;
opacity: 1;
border: 2px solid #BDEDFF;
}
.nrboxr>h3{
    margin-top: 41px;
    margin-bottom: 41px;
font-size: 30px;
font-family: Source Han Sans CN-Bold, Source Han Sans CN;
font-weight: bold;
color: #3661FE;
line-height: 35px;
text-align: center;
}
.nrboxr>div{
  width: 297px;
height: 45px;
border-radius: 2px 2px 2px 2px;
opacity: 1;
border: 1px solid #DFDFDF;
margin: 0 auto;
margin-bottom: 15px;
display: flex;
}
.nrboxr>div>img{
    margin-top: 14px;
    margin-left: 10px;
    margin-right: 7px;
    display: block;
    width: 15px;
    height: 19px;
}
.nrboxr>div>input{
    width: 262px;
    border-style: none;
  border: none;
  border: 0;
font-size: 16px;
font-weight: 400;
color: #AAAAAA;
}
.nrboxr>div>input::-webkit-input-placeholder{
    color: #AAAAAA;
}
.nrboxr>div>input:focus{
    outline: 0px solid #f2f2f2;
}
.nrboxr>span{
    position: absolute;
    left: 35px;
    bottom: 67px;
    display: block;
    width: 297px;
height: 45px;
background: #4C5CF7;
box-shadow: 0px 8px 25px 1px rgba(36, 83, 255, 0.35);
border-radius: 2px 2px 2px 2px;
opacity: 1;
font-size: 16px;
color: #FFFFFF;
line-height: 45px;
text-align: center;
}
</style>
